import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://baseball.fandom.com/wiki/Earned_run
// A run is counted as unearned when: A batter reaches base on an error (including catcher's interference), and later scores a run in that inning.
const classifiesAsUnearnedRun = function(paResult) {
    // A run is counted as unearned when: @see https://en.wikipedia.org/wiki/Earned_run#
    switch (paResult) {
        // A batter reaches base on an error (including catcher's interference) that would have retired the batter except for the error, and later scores a run in that inning by any means.
        case PlateAppearanceResult.CatcherInterference.key:
        case PlateAppearanceResult.ReachedOnError.key:
        // A batter reaches first base on a passed ball (but not a wild pitch) and later scores.
        case PlateAppearanceResult.PassedBall.key:
            return true;

        // outs...
        case PlateAppearanceResult.FieldOut.key:
        case PlateAppearanceResult.FoulOut.key:
        case PlateAppearanceResult.FoulTipOut.key:
        case PlateAppearanceResult.InfieldFly.key:
        case PlateAppearanceResult.SacrificeBunt.key:
        case PlateAppearanceResult.SacrificeFly.key:
        case PlateAppearanceResult.SacrificePlay.key:
        case PlateAppearanceResult.CalledStrikeout.key:
        case PlateAppearanceResult.SwingingStrikeout.key:
        case PlateAppearanceResult.BatterInterference.key:
        case PlateAppearanceResult.InfieldFly.key:
        case PlateAppearanceResult.BatterOut.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsUnearnedRun;